<div class="w-100 d-flex justify-center">
    <div class="page-loader"></div>
</div>